<template>
	<div class="xs-12 p4">
		<div class="pb2 fs3 fw7">{{ $t("name") }}</div>
		<j-base-input-text
			class="mb4"
			size="small"
			v-model="fileNameWithoutExtension"
		/>
		<div class="r2 flex xs-middle bg5 bc7 b1 p2 mb4">
			<crm-icon name="warning" size="large" class="pt1" color="c6" />
			<div class="pl2 fs3 lh125 c6">
				{{ $t("rename_file_disclaimer") }}
			</div>
		</div>
		<div class="flex xs-12 xs-center">
			<j-button type="primary" size="small" @click="submit">{{
				$t("submit")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	name: "RenameFileInput",

	components: { JBaseInputText, JButton, CrmIcon },

	props: {
		fileName: String
	},

	data() {
		return {
			fileNameWithoutExtension: this.fileName.includes(".")
				? this.fileName
						.split(".")
						.slice(0, -1)
						.join(".")
				: this.fileName,
			extension: this.fileName.includes(".")
				? "." + this.fileName.split(".").pop()
				: ""
		}
	},

	methods: {
		submit() {
			if (this.fileNameWithoutExtension.length) {
				this.$emit("input", this.fileNameWithoutExtension + this.extension)
			} else {
				this.$store.dispatch("showMessage", ["Please enter a filename."])
			}
		}
	}
}
</script>
